import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '../components/ui/Button'
import { AuthContext } from '../context'

const Main = () => {
  const { isAuthAdmin } = useContext(AuthContext)
  const redirect = useNavigate()

  const hasAccess = () => {
    if (isAuthAdmin) {
        redirect("/student/login")
    } else {
        alert("Администратор не вошел в личный кабинет")
    }
  }
  
  return (
    <section className="main">
        <div className="main__container container">
            <div className="main__content">
                <h1 className="main__title title">Анкета "Преподаватель глазами студента"</h1>
                <div className="main__desc">
                    <p>
                        Уважаемые студенты, просим вас принять участие в анкетировании и ответить на предлагаемые вопросы. 
                        Ваши искренние ответы помогут нам разработать и провести мероприятия по повышению качества организации учебного процесса и уровня преподавания в ДГУ.
                        При ответе на большинство вопросов анкеты применяется пятибалльная шкала оценки от 1 до 5, где 1 – низкая, а 5 – высокая. Нужное следует отметить.
                    </p>
                    <p>Все комментарии и пояснения к ответам приветствуются!</p>
                    <p>Данное исследование и его результаты будут использованы только в обобщенном виде, а данные о ФИО студентов будут засекречены.</p>
                </div>
            </div>
            <div className="main__bottom">
                <h2 className="main__bottom-title title">Зайти в систему и начать анкетирование</h2>
                <Button onClick={() => hasAccess()} className="main__bottom-btn btn">Зайти</Button>
            </div>
        </div>
    </section>
  )
}

export default Main